import React, { Component } from 'react';

// Elements
import Container from 'react-bootstrap/Container'
import PageHero from '../PageHero/PageHero';

export default class Custom extends Component {

    render() {
        let page = this.props.page;
        // "UNCAT" means the page isn't in any category; no category means no label
        const category = (page.category || '').trim();
        const eyebrow = category && category.toUpperCase() !== 'UNCAT' ? category : null;
        return (
            <>
                <PageHero eyebrow={eyebrow} title={page.title || page.name}/>
                <Container className="custom-page">
                    <div className="custom-content" dangerouslySetInnerHTML={{__html:page.html}}></div>
                </Container>
            </>
        );
    }
}
